import { render, staticRenderFns } from "./ImportProposalPage.vue?vue&type=template&id=2724a1fb"
import script from "./ImportProposalPage.vue?vue&type=script&lang=js"
export * from "./ImportProposalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports